import SAVE_BUSINESS from './saveBusiness.gql';

export default SAVE_BUSINESS;
export { SAVE_BUSINESS };
